import classNames from 'classnames';

interface IconProps {
  className?: string;
  isBlack?: boolean;
  isRelative?: boolean;
}

export const IconArrowRight = ({
  className,
  isBlack,
  isRelative,
}: IconProps) => {
  return (
    <i
      className={classNames(className, 'icon', {
        'icon-arrow-right-black': isBlack,
        'icon-arrow-right-white': !isBlack,
        relative: isRelative,
      })}
    />
  );
};

function inlineIcon(iconClass: string, className?: string) {
  return <i className={classNames('icon', 'icon--inline', iconClass, className)} />;
}

function maskIcon(iconClass: string, className?: string) {
  return (
    <i className={classNames('icon', 'icon--inline', 'icon--mask', iconClass, className)} />
  );
}

export const IconPlus = ({ className }: IconProps) => inlineIcon('icon-plus', className);

export const IconPlusWhite = ({ className }: IconProps) =>
  inlineIcon('icon-plus-white', className);

export const IconClock = ({ className }: IconProps) => inlineIcon('icon-clock', className);

export const IconPrice = ({ className }: IconProps) => inlineIcon('icon-price', className);

export const IconPackage = ({ className }: IconProps) => inlineIcon('icon-package', className);

export const IconChevronRight = ({ className }: IconProps) =>
  inlineIcon('icon-chevron-right', className);

export const IconMore = ({ className }: IconProps) => inlineIcon('icon-more', className);

export const IconCalendarPlus = ({ className }: IconProps) =>
  inlineIcon('icon-calendar-plus', className);

export const IconUser = ({ className }: IconProps) => maskIcon('icon-user', className);

export const IconEducation = ({ className }: IconProps) => maskIcon('icon-education', className);

export const IconSkills = ({ className }: IconProps) => maskIcon('icon-skills', className);

export const IconLanguages = ({ className }: IconProps) => maskIcon('icon-languages', className);

export const IconAvailability = ({ className }: IconProps) =>
  maskIcon('icon-availability', className);

export const IconChevron = ({ className }: IconProps) => maskIcon('icon-chevron', className);

export const IconBriefcase = ({ className }: IconProps) => inlineIcon('icon-briefcase', className);

export const IconGlobe = ({ className }: IconProps) => inlineIcon('icon-globe', className);

export const IconCoin = ({ className }: IconProps) => inlineIcon('icon-coin', className);

export const IconLessonAside = ({ className }: IconProps) =>
  inlineIcon('icon-lesson-aside', className);

export const IconCalendar = ({ className }: IconProps) => maskIcon('icon-calendar', className);

export const IconCheckCircle = ({ className }: IconProps) =>
  maskIcon('icon-check-circle', className);
